import {useState} from "react";
import {apiLogin, apiMe, apiRegister} from "../api/auth";

export function useAuth() {
    const [user, setUser] = useState(null);

    async function initFromToken() {
        const token = localStorage.getItem("paroles_agents_token");
        if (!token) return;
        const data = await apiMe();
        if (data) {
            setUser(data);
            localStorage.setItem("paroles_agents_user", JSON.stringify(data));
        } else {
            localStorage.removeItem("paroles_agents_token");
            localStorage.removeItem("paroles_agents_user");
        }
    }

    async function login(username, password) {
        const data = await apiLogin(username, password);
        if (data.error) return {error: data.error, code: data.code};
        setUser(data.user);
        localStorage.setItem("paroles_agents_user", JSON.stringify(data.user));
        localStorage.setItem("paroles_agents_token", data.token);
        return null;
    }

    async function register(email, username, password, cguAccepted) {
        const data = await apiRegister(email, username, password, cguAccepted);
        if (data.error) return data.error;
        return null;
    }

    function logout() {
        setUser(null);
        localStorage.removeItem("paroles_agents_user");
        localStorage.removeItem("paroles_agents_token");
    }

    return {user, setUser, login, logout, register, initFromToken};
}
